import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { Logo } from './Logo';
import { PhoneIcon, MailIcon, MenuIcon, XIcon } from 'lucide-react';
export function Header() {
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);
  return <header className="bg-white shadow-sm sticky top-0 z-50" data-id="element-93">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-94">
        <div className="flex justify-between items-center py-4" data-id="element-95">
          <Link to="/" data-id="element-96">
            <Logo data-id="element-97" />
          </Link>
          <nav className="hidden lg:flex items-center gap-6" data-id="element-98">
            <Link to="/" className="text-slate-700 hover:text-teal-600 transition text-sm" data-id="element-99">
              Home
            </Link>
            <Link to="/services" className="text-slate-700 hover:text-teal-600 transition text-sm" data-id="element-100">
              Repair Service Details
            </Link>
            <Link to="/faq" className="text-slate-700 hover:text-teal-600 transition text-sm" data-id="element-101">
              FAQs
            </Link>
            <Link to="/cancellation" className="text-slate-700 hover:text-teal-600 transition text-sm" data-id="element-102">
              Cancellation
            </Link>
            <Link to="/refund" className="text-slate-700 hover:text-teal-600 transition text-sm" data-id="element-103">
              Refund
            </Link>
            <Link to="/privacy-policy" className="text-slate-700 hover:text-teal-600 transition text-sm" data-id="element-104">
              Privacy & Cookies
            </Link>
            <Link to="/terms-of-service" className="text-slate-700 hover:text-teal-600 transition text-sm" data-id="element-105">
              Terms & Conditions
            </Link>
            <Link to="/contact" className="text-slate-700 hover:text-teal-600 transition text-sm" data-id="element-106">
              Contact
            </Link>
          </nav>
          <div className="flex items-center gap-4" data-id="element-107">
            <div className="hidden xl:flex flex-col text-right text-sm" data-id="element-108">
              <a href="tel:08000554969" className="flex items-center gap-1 text-teal-700 font-semibold" data-id="element-109">
                <PhoneIcon className="w-4 h-4" data-id="element-110" />
                0800 055 4969
              </a>
              <a href="mailto:Sumittandon092@gmail.com" className="flex items-center gap-1 text-slate-600 text-xs" data-id="element-111">
                <MailIcon className="w-3 h-3" data-id="element-112" />
                Sumittandon092@gmail.com
              </a>
            </div>
            <button onClick={() => setMobileMenuOpen(!mobileMenuOpen)} className="lg:hidden text-slate-700 hover:text-teal-600" data-id="element-113">
              {mobileMenuOpen ? <XIcon className="w-6 h-6" data-id="element-114" /> : <MenuIcon className="w-6 h-6" data-id="element-115" />}
            </button>
          </div>
        </div>
        {mobileMenuOpen && <nav className="lg:hidden pb-4 border-t border-slate-200 pt-4" data-id="element-116">
            <div className="flex flex-col space-y-3" data-id="element-117">
              <Link to="/" className="text-slate-700 hover:text-teal-600 transition" onClick={() => setMobileMenuOpen(false)} data-id="element-118">
                Home
              </Link>
              <Link to="/services" className="text-slate-700 hover:text-teal-600 transition" onClick={() => setMobileMenuOpen(false)} data-id="element-119">
                Repair Service Details
              </Link>
              <Link to="/faq" className="text-slate-700 hover:text-teal-600 transition" onClick={() => setMobileMenuOpen(false)} data-id="element-120">
                FAQs
              </Link>
              <Link to="/cancellation" className="text-slate-700 hover:text-teal-600 transition" onClick={() => setMobileMenuOpen(false)} data-id="element-121">
                Cancellation
              </Link>
              <Link to="/refund" className="text-slate-700 hover:text-teal-600 transition" onClick={() => setMobileMenuOpen(false)} data-id="element-122">
                Refund
              </Link>
              <Link to="/privacy-policy" className="text-slate-700 hover:text-teal-600 transition" onClick={() => setMobileMenuOpen(false)} data-id="element-123">
                Privacy & Cookies
              </Link>
              <Link to="/terms-of-service" className="text-slate-700 hover:text-teal-600 transition" onClick={() => setMobileMenuOpen(false)} data-id="element-124">
                Terms & Conditions
              </Link>
              <Link to="/contact" className="text-slate-700 hover:text-teal-600 transition" onClick={() => setMobileMenuOpen(false)} data-id="element-125">
                Contact
              </Link>
            </div>
          </nav>}
      </div>
    </header>;
}